module.exports = {
	"pagination": {
		"ListCustomVerificationEmailTemplates": {
			"input_token": "NextToken",
			"limit_key": "MaxResults",
			"output_token": "NextToken"
		},
		"ListIdentities": {
			"input_token": "NextToken",
			"limit_key": "MaxItems",
			"output_token": "NextToken",
			"result_key": "Identities"
		},
		"ListVerifiedEmailAddresses": {
			"result_key": "VerifiedEmailAddresses"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/email-2010-12-01.paginators.json
// module id = 2117
// module chunks = 0